import { defaultFlags, type Flags } from './defaultFlags'
import { SET_FLAGS } from './FlagsConstants'

interface SetFlagsAction {
  type: typeof SET_FLAGS
  payload: Flags
}

const initialState = {
  flags: defaultFlags,
}

export type FlagsState = typeof initialState

export default function flagsReducer(state: FlagsState = initialState, action: SetFlagsAction) {
  switch (action.type) {
    case SET_FLAGS:
      return {
        ...state,
        flags: action.payload,
      }
    default:
      return state
  }
}
